import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {tap} from 'rxjs';
import {NotificationService} from '../../core/services/notification.service';
import {Notification, NotificationType} from '../../core/models/notification.model';
import {ServerResponse} from '../../core/models/server-response.model';
import {ErrorUtil} from '../../core/utils/error.util';
import {MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-notification-settings',
    templateUrl: './notification.component.html',
    providers: [MessageService]
})
export class NotificationComponent implements OnInit {
    newFollower: Notification = undefined;
    commentOwnDeal: Notification = undefined;
    commentReply: Notification = undefined;
    newFollowerSwitch = false;
    commentOwnDealSwitch = false;
    commentReplySwitch = false;
    constructor(
        private notificationService: NotificationService,
        private messageService: MessageService,
        private translate: TranslateService,
        private router: Router
    ) {
    }
    ngOnInit() {
        this.notificationService.getAll().pipe(tap( notifs => {
            this.newFollower = notifs.filter(item => item.notification_type === NotificationType.Following).shift();
            this.commentOwnDeal = notifs.filter(item => item.notification_type === NotificationType.CommentOnDeal
                && item.notification_link_id === undefined).shift();
            this.commentReply = notifs.filter(item => item.notification_type === NotificationType.ReplyOnComment).shift();
            this.newFollowerSwitch = (this.newFollower !== undefined) ? (this.newFollower.notification_active === 1) : false;
            this.commentOwnDealSwitch = (this.commentOwnDeal !== undefined) ? (this.commentOwnDeal.notification_active === 1) : false;
            this.commentReplySwitch = (this.commentReply !== undefined) ? (this.commentReply.notification_active === 1) : false;
        },
            error => {
            // handle error
            })).subscribe();
    }
    public get notificationType(): typeof NotificationType {
        return NotificationType;
    }
    handleChange(event, type: NotificationType, notification) {
        if (notification === undefined && event.checked === true) {
           this.notificationService.add(type, undefined, undefined, undefined).pipe(tap(
               notif => this.handleSuccess(notif),
               error => this.handleError(error)
           )).subscribe();
        } else if (notification !== undefined) {
            this.notificationService.editStatus(event.checked, notification.notification_id).pipe(tap(
                notif => this.handleSuccess(notif),
                error => this.handleError(error)
            )).subscribe();
        }
    }
    handleSuccess(notif: Notification) {
        switch (notif.notification_type) {
            case NotificationType.Following: {
                this.newFollower = notif;
                this.newFollowerSwitch = (notif.notification_active === 1);
                break;
            }
            case NotificationType.CommentOnDeal: {
                this.commentOwnDeal = notif;
                this.commentOwnDealSwitch = (notif.notification_active === 1);
                break;
            }
            case NotificationType.ReplyOnComment: {
                this.commentReply = notif;
                this.commentReplySwitch = (notif.notification_active === 1);
                break;
            }
        }
    }
    handleError(response: ServerResponse) {
        this.messageService.add({severity: 'error',
            summary: this.translate.instant('error'),
            detail: this.translate.instant(new ErrorUtil(response.error).description)
        });
    }
}
